module.exports = __webpack_public_path__ + "static/media/doctor-video-chat.4726c7dc.png";